import { useQuery } from "@tanstack/react-query";
import { getFilterOptions } from "../api/endpoints";
import { qk } from "../api/queryKeys";

export default function useFilters(category, { enabled = true } = {}) {
  return useQuery({
    queryKey: qk.filters(category),
    queryFn: ({ signal }) => getFilterOptions(category, { signal }),
    enabled: !!category && enabled,
    staleTime: 10 * 60 * 1000,
  });
}
